import { Injectable } from '@angular/core';
import { TradingAccount } from '../../../../../../domain/account.domain';
import { OrderSecurity } from '../../../../../../domain/security.domain';
import {
  OrderCapture,
  OrderTerms,
  OrderRequest,
  TradingCredential,
  Strategy,
  PricePlan,
  OrderItem
} from '../../../../domain';

import { BackendMapper } from '../../../domain/services.domain';
import { OrderEntryUtilityService } from '../../order-entry-utility.service';

@Injectable()
export abstract class CreateOrderMapper<T> implements BackendMapper<T> {
  createCaptureRequest(form: T,
                       selectedAccount: TradingAccount,
                       tradingCredential: TradingCredential,
                       strategy: Strategy = Strategy.SPL): OrderRequest {
    const request = {
      orderTerms: {
        accountInfo: { accountId: selectedAccount.id },
        afterMarket: false,
        order: this.getItems(form),
        pricePlan: PricePlan.MARKET,
        strategy
      },
      conditionFilter: 'STANDARD'
    } as OrderRequest;
    if (tradingCredential !== undefined) {
      request.tradingCredential = tradingCredential;
    }
    return request;
  }

  createOrderRequest(orderCaptureResponse: OrderCapture<OrderTerms>): OrderRequest<OrderTerms> {
    if (Object.keys(orderCaptureResponse.conditions.conditions).length === 0) {
      return {
        orderTerms: orderCaptureResponse.orderTerms,
        conditionFilter: 'STANDARD'
      };
    }
    const order = {
      orderTerms: orderCaptureResponse.orderTerms,
      conditionFilter: 'STANDARD',
      acknowledgements: {
        conditions: orderCaptureResponse.conditions.conditions
      }
    };

    OrderEntryUtilityService.acknowledgeConditions(order.acknowledgements.conditions, orderCaptureResponse.conditions);
    return order;
  }

  // validateTradingOrder(order: OrderRequest): Observable<OrderCapture<OrderTerms>> {
  //   return this.orderEntryRestService.validateOrder(order);
  // }

  // submitTradingOrder(orderCapture: OrderCapture<OrderTerms>): Observable<OrderCapture<OrderTerms>> {
  //   return this.orderEntryRestService.createTradingOrder(this.createOrderRequest(orderCapture));
  // }

  abstract getItems(form: T): Array<OrderItem>;
  abstract getMapperType(): OrderSecurity;
}

